// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

async function fetchFileSummary(formData) {
	const url = `${process.env.API_URL}/summary/file`;
	const response = await fetch(url, {
		method: "POST",
		body: formData,
	});
	return response;
}

export default fetchFileSummary;
